// Single source of truth for the visible app version (footer).
// Reads from package.json at build time so bumping the "version" field is
// the only step required for a new release.
import pkg from '../package.json';

export const APP_VERSION = `v${pkg.version}`;
